define('views/modules/questionnaire/modal/fill-questionnaire-content',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/session',
    'services/api',
    'services/i18n',
    // views
    'views/modules/questionnaire/member/questions-list',
    'src/views/form-view',
    // collections
    'collections/member/supervisors',
    'collections/conversation/conversations',
    // templates
    'text!templates/modules/questionnaire/modal/fill-questionnaire-content.html'
], function(
    // libs
    _, Backbone, Mustache, U,
    // services
    Session,
    API,
    i18n,
    // views
    VQuestionsList,
    VForm,
    // collections
    Supervisors,
    CConversations,
    // templates
    TFillQuestionnaireContent
) {

    var VFillQuestionnaireContent = VForm.extend({
        template: TFillQuestionnaireContent,

        regions: {
            list: '.questions-list',
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                group: opt.group,
                questionnaire: opt.questionnaire
            });

            var model = this.model,
                conversations = this.conversations = new CConversations(),
                collection = this.collection = model.getQuestions(),
                view = this.view = {
                    list: new VQuestionsList({
                        model: model,
                        collection: collection,
                    })
                };

            this.listenTo(collection, { 'change': this.onCollectionChange });
            this.listenTo(model, { 'change:_questions': this.onQuestionsChange });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.questionnaire.toJSON())));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list);

            return this;
        },

        isDirty: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        sendNotificationToSupervisors: function() {
            var model = this.model;

            Supervisors.each(function(supervisor) {
                this.conversations.add({
                    message: i18n.t("conversation:member_answered_questionnaire_message"),
                    user: supervisor.id,
                    type: 'questionnaireResponse',
                    activity: model.getQuestionnaire() + ":" + model.id
                }, { sort: false });
            }, this);

            this.conversations.bulkCreate({
                success: this.onFeedbackSent,
                context: this
            });

            return this;
        },

        /////////////
        // events ///
        /////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onSubmit: function() {
            this.model.setAnswers()
                .setQuestionnaire(this.questionnaire);
        },

        onSuccess: function() {
            this.sendNotificationToSupervisors();
        },

        onSaveButton: function() {
            this.submit();
        },

        onQuestionsChange: function(model, value) {
            var collection = this.collection;
            collection.reset(value.models);
            this.collectionCopy = collection.toJSON();
        },

    });

    return VFillQuestionnaireContent;

});

